export const buildQueryString = (queryParams: {
  [key: string]: string;
}): string => {
  const filteredParams = Object.keys(queryParams).filter((q) => queryParams[q]);
  return filteredParams
    .map((key) => (queryParams[key] ? key + '=' + queryParams[key] : ''))
    .join('&');
};
